/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateElectronBeamQualityDoseRateValueListDto } from './CreateElectronBeamQualityDoseRateValueListDto';
import {
    instanceOfCreateElectronBeamQualityDoseRateValueListDto,
    CreateElectronBeamQualityDoseRateValueListDtoFromJSON,
    CreateElectronBeamQualityDoseRateValueListDtoFromJSONTyped,
    CreateElectronBeamQualityDoseRateValueListDtoToJSON,
} from './CreateElectronBeamQualityDoseRateValueListDto';
import type { CreatePhotonBeamQualityDoseRateValueListDto } from './CreatePhotonBeamQualityDoseRateValueListDto';
import {
    instanceOfCreatePhotonBeamQualityDoseRateValueListDto,
    CreatePhotonBeamQualityDoseRateValueListDtoFromJSON,
    CreatePhotonBeamQualityDoseRateValueListDtoFromJSONTyped,
    CreatePhotonBeamQualityDoseRateValueListDtoToJSON,
} from './CreatePhotonBeamQualityDoseRateValueListDto';

/**
 * @type CreateBeamQualityDoseRateValueListDto
 * 
 * @export
 */
export type CreateBeamQualityDoseRateValueListDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateElectronBeamQualityDoseRateValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateElectronBeamQualityDoseRateValueListDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreatePhotonBeamQualityDoseRateValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreatePhotonBeamQualityDoseRateValueListDto;


export function CreateBeamQualityDoseRateValueListDtoFromJSON(json: any): CreateBeamQualityDoseRateValueListDto {
    return CreateBeamQualityDoseRateValueListDtoFromJSONTyped(json, false);
}

export function CreateBeamQualityDoseRateValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBeamQualityDoseRateValueListDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateElectronBeamQualityDoseRateValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateElectronBeamQualityDoseRateValueListDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateElectronBeamQualityDoseRateValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreatePhotonBeamQualityDoseRateValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreatePhotonBeamQualityDoseRateValueListDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreatePhotonBeamQualityDoseRateValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of CreateBeamQualityDoseRateValueListDto exists with '$type=${json['$type']}'`);
    }
}

export function CreateBeamQualityDoseRateValueListDtoToJSON(value?: CreateBeamQualityDoseRateValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateElectronBeamQualityDoseRateValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateElectronBeamQualityDoseRateValueListDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreatePhotonBeamQualityDoseRateValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreatePhotonBeamQualityDoseRateValueListDtoToJSON(value);
        default:
            throw new Error(`No variant of CreateBeamQualityDoseRateValueListDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the CreateBeamQualityDoseRateValueListDto interface.
 */
export function instanceOfCreateBeamQualityDoseRateValueListDto(value: any): value is CreateBeamQualityDoseRateValueListDto {
    if (instanceOfCreateElectronBeamQualityDoseRateValueListDto(value)) return true;
    if (instanceOfCreatePhotonBeamQualityDoseRateValueListDto(value)) return true;
    return false;
}

